export const LocalStorage = {
  get(this: any, key: string): any {
    return this.hasKey(key) ? JSON.parse(localStorage.getItem(key)!) : null;
  },
  set(key: string, value: any): any {
    localStorage.setItem(key, JSON.stringify(value));
  },
  remove(key: string) {
    localStorage.removeItem(key);
  },
  hasKey(key: string): boolean {
    return key in localStorage;
  },
  emit(key: string, value: any) {
    this.set(key, value);
    this.remove(key);
  },
  on(key: string, callbackFunction: any) {
    window.addEventListener('storage', (event) => functionHandler(event, key, callbackFunction));
  },
  off(key: string, callbackFunction: any) {
    window.removeEventListener('storage', (event) => functionHandler(event, key, callbackFunction));
  }
};

function functionHandler(event: any, key: string, callbackFunction: any) {
  if (event.key !== key || !event.newValue) {
    return;
  }
  callbackFunction(JSON.parse(event.newValue));
}
